import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';

// PayTR, HashRouter dışı bir path'e dönerse adres
// /pay/renewal/{token}?merchantOid=...#/accounting/dashboard şeklini alır
// ve teşekkür sayfası hiç açılmaz. Uygulama boyanmadan hash rotasına çevir.
const renewalReturn = window.location.pathname.match(/^\/pay\/renewal\/([^/?#]+)/);
if (renewalReturn) {
  const token = renewalReturn[1];
  const incoming = new URLSearchParams(window.location.search);
  const payment = (incoming.get('payment') || '').toLowerCase() === 'fail' ? 'fail' : 'return';
  const params = new URLSearchParams();
  params.set('payment', payment);
  const merchantOid = incoming.get('merchantOid');
  if (merchantOid) params.set('merchantOid', merchantOid);
  window.location.replace(
    `${window.location.origin}/#/pay/renewal/${encodeURIComponent(token)}?${params.toString()}`,
  );
} else {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}
